import React from 'react';
import styles from './Tags.module.sass';
import PreferedTagsSettings from 'components/PreferedTagsSettings';

const Tags = () => {
  return <PreferedTagsSettings className={styles.container} />;
};
export default Tags;
